import { render, staticRenderFns } from "./HotelForm.vue?vue&type=template&id=68a34cf2&lang=pug&"
import script from "./HotelForm.vue?vue&type=script&lang=js&"
export * from "./HotelForm.vue?vue&type=script&lang=js&"
import style0 from "./HotelForm.vue?vue&type=style&index=0&id=68a34cf2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports